import { render, staticRenderFns } from "./RadioComponent.vue?vue&type=template&id=50127bcd"
import script from "./RadioComponent.vue?vue&type=script&lang=js"
export * from "./RadioComponent.vue?vue&type=script&lang=js"
import style0 from "./RadioComponent.vue?vue&type=style&index=0&id=50127bcd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports